import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TestStep } from '../dto/test-step';

@Injectable({
  providedIn: 'root'
})
export class TestStepService {
  private apiUrl = environment.apiRoot + '/teststep';

  constructor(private http: HttpClient) { }

  getAllTestStepsOfTest(testId: number): Observable<TestStep[]> {
    return this.http.get<TestStep[]>(this.apiUrl + '/alloftest?testId=' + testId);
  }

  createTestStep(testId: number): Observable<TestStep> {
    let model = { "id": 0, "test_id": testId, "sn": "new test step" };
    return this.http.post<TestStep>(this.apiUrl + '/new', model);
  }

  updateTestStep(model: TestStep): Observable<TestStep> {
    return this.http.put<TestStep>(this.apiUrl + '/update', model);
  }

  deleteTestStep(testStepId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?testStepId=' + testStepId);
  }
}
